export { default as MedHorizontalBarChart } from './MedHorizontalBarChart';
export type {
  MedHorizontalBarChartProps,
  HorizontalBarDatum,
} from './MedHorizontalBarChart';
